import React from 'react';
import { Box, Grid, Skeleton } from '@mui/material';

export default function DetailSkeleton() {
  return (
    <Box>
      <Grid container spacing={2} sx={{ mb: 3 }}>
        {[1, 2, 3, 4].map((i) => (
          <Grid item xs={12} sm={6} md={3} key={i}>
            <Skeleton variant="rounded" height={68} animation="wave" />
          </Grid>
        ))}
      </Grid>
      <Skeleton variant="rounded" width="100%" height={220} animation="wave" sx={{ mb: 2 }} />
      <Skeleton variant="rounded" width="100%" height={220} animation="wave" />
    </Box>
  );
}
